import React from 'react';
import MarketResearch from './MarketResearch';
import NewsList from './NewsList';
import RedditList from './RedditList';
import OECDTable from './OECDTable';
import MarketAnalysis from './MarketAnalysis';
import MastodonList from './MastodonList';

function Results({ data }) {
  console.log('Results component received data:', data);

  // 统一数据格式
  const validatedData = React.useMemo(() => {
    if (!data) {
      console.warn('Results: No data provided');
      return { error: 'No data available' };
    }

    // 处理直接返回的数据结构
    if (data.analysis || data.news || data.reddit || data.mastodon || data.oecd) {
      return data;
    }

    // 处理包装在 data 属性中的数据结构
    if (data.data && typeof data.data === 'object') {
      return data.data;
    }

    console.warn('Results: Invalid data structure', data);
    return { error: 'Invalid data structure' };
  }, [data]);

  console.log('Response data structure:', validatedData);

  // 处理分析数据
  if (validatedData.analysis) {
    console.log('Raw analysis data:', validatedData.analysis);
    console.log('Analysis content available:', Boolean(validatedData.analysis.content));
  }

  return (
    <div className="results-container">
      {validatedData.error && (
        <div className="alert alert-warning mb-4">
          <p>{validatedData.error}</p>
          <small>Showing available results below</small>
        </div>
      )}

      {/* Show Analysis first if available */}
      {validatedData.analysis && validatedData.analysis.status === 'success' && (
        <div className="row mb-4">
          <div className="col-12">
            <MarketAnalysis 
              analysis={validatedData.analysis}
              keywords={validatedData.keywords || ''}
              region={validatedData.region || ''}
            />
          </div>
        </div>
      )}

      {/* Show other results even if some sources failed */}
      <div className="row">
        {validatedData.news?.length > 0 && (
          <div className="col-12 mb-4">
            <NewsList news={validatedData.news} />
          </div>
        )}

        {validatedData.reddit?.length > 0 && (
          <div className="col-12 mb-4">
            <RedditList posts={validatedData.reddit} />
          </div>
        )}

        {validatedData.mastodon?.length > 0 && (
          <div className="col-12 mb-4">
            <MastodonList posts={validatedData.mastodon} />
          </div>
        )}

        {Object.keys(validatedData.oecd || {}).length > 0 && (
          <div className="col-12 mb-4">
            <OECDTable data={validatedData.oecd} />
          </div>
        )}
      </div>
    </div>
  );
}

export default Results;
